<ng-container [formGroup]="form">
    <fieldset class="_toggle-switch _gap-1">
        <label class="switch" [for]="fieldId">
            <input 
                [formControlName]="fieldId"
                [id]="fieldId"
                [value]="value"
                type="checkbox">
            <span class="slider"></span>
        </label>
        <ng-content></ng-content>
    </fieldset>
</ng-container>


